const Languages = () => {
  return (
    <section className="languages">
      <h2 className="title-font  pink-text h2-tag">Languages</h2>
      <section>
        <h3 className="title-font  pink-text">English</h3>
        <p className="title-font  white-text">Native or bilingual proficiency</p>
        <h3 className="title-font  pink-text">Gujarati</h3>
        <p className="title-font  white-text">Bilingual proficiency</p>
        <h3 className="title-font  pink-text">Hindi</h3>
        <p className="title-font  white-text">Elementary proficiency</p>
      </section>
    </section>
  );
};

export default Languages;
